import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {LinkGroupService} from '../../../shared/link/link-group.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Modal} from '@common/core/ui/dialogs/modal.service';
import {DatatableService} from '@common/datatable/datatable.service';
import {Link} from '../../../shared/link/link';
import {LinkUsageService} from '../../../shared/link/link-usage.service';
import {LinkService} from '../../../shared/link/link.service';
import {Toast} from '@common/core/ui/toast.service';
import {CurrentUser} from '@common/auth/current-user';
import {Messages} from '../../../messages.enum';
import {BackendErrorResponse} from '@common/core/types/backend-error-response';
import {HttpErrors} from '@common/core/http/errors/http-errors.enum';
import {
    CrupdateLinkModalComponent,
    CrupdateLinkModalData,
} from '../../link/crupdate-link-modal/crupdate-link-modal.component';
import {ConfirmModalComponent} from '@common/core/ui/confirm-modal/confirm-modal.component';
import {
    AttachLinkModalComponent,
    AttachLinkModalData,
} from '../attach-link-modal/attach-link-modal.component';
import {LinkGroup} from '../../../shared/link/link-group';
import {SKELETON_ANIMATIONS} from '@common/core/ui/skeleton/skeleton-animations';
import {LINK_INDEX_FILTERS} from '../../link/link-index/link-index-filters';
import {DatatableFilter} from '@common/datatable/datatable-filters/search-input-with-filters/filter-config/datatable-filter';

@Component({
    selector: 'link-group-links-index',
    templateUrl: './link-group-links-index.component.html',
    styleUrls: ['./link-group-links-index.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: SKELETON_ANIMATIONS,
    providers: [DatatableService],
})
export class LinkGroupLinksIndexComponent implements OnInit {
    filters: DatatableFilter[];
    loading$ = new BehaviorSubject(false);
    groupId$ = new BehaviorSubject<number>(null);

    constructor(
        public route: ActivatedRoute,
        private modal: Modal,
        public datatable: DatatableService<Link>,
        private linkUsage: LinkUsageService,
        private linkGroups: LinkGroupService,
        private links: LinkService,
        private toast: Toast,
        private router: Router,
        public currentUser: CurrentUser
    ) {}

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.groupId$.next(params.groupId);
        });
        // this.setFilters();
        // this.datatable.init({
        //     uri: `${LinkGroupService.BASE_URI}/${this.route.snapshot.params.groupId}/links`,
        // });
        //
        // this.datatable.paginator.response$.subscribe(response => {
        //     this.linkGroup$.next(response?.linkGroup as LinkGroup);
        // });
    }

    filterByUser(): boolean {
        return this.router.url.indexOf('admin') === -1;
    }

    private setFilters() {
        this.filters = LINK_INDEX_FILTERS.filter(
            f => f.key !== 'user_id' || !this.filterByUser()
        );
    }
}
